import {useEffect, useState} from "react"

/** Custom event name dispatched by `window.ri2.setPageContext`. */
export const PAGE_CONTEXT_EVENT = "ri2:pagecontext"

/**
 * Reactively tracks the page context set by the host page.
 *
 * Reads the initial value from `window.ri2.pageContext` and listens for
 * subsequent updates via the `ri2:pagecontext` CustomEvent (dispatched by
 * `window.ri2.setPageContext`).
 */
export const usePageContext = (): Ri2PageContext | null => {
  const [context, setContext] = useState<Ri2PageContext | null>(
    () => window.ri2?.pageContext ?? null,
  )

  useEffect(() => {
    const handler = (e: Event): void => {
      const detail = (e as CustomEvent<Ri2PageContext | null>).detail
      setContext(detail ?? null)
    }

    window.addEventListener(PAGE_CONTEXT_EVENT, handler)
    return (): void => window.removeEventListener(PAGE_CONTEXT_EVENT, handler)
  }, [])

  return context
}
